import SelectionForm from './SelectionForm'
import { AnalysisProvider } from './contextProvider'

export default function FastTrack(): JSX.Element {
  return (
    <AnalysisProvider>
      <SelectionForm />
    </AnalysisProvider>
  )
}
